import React from 'react';

type Props = {
    bodyMsg: string | undefined
}

const Mail = (props: Props) => {
    let mailTo = "xyz@gmail.com";
    let subject = "Testing";
    let cc = "xyz@testing.com";
    let bcc = "abc@testing.com";
    return (
        <a
            href={`mailto:${mailTo}?cc=${cc}&bcc=${bcc}&subject=${subject}&body=${props.bodyMsg}`}
            target="_blank"
        >
            Email
        </a>
    )
}

export default Mail